import axios from 'axios';
import { API_GET_DOMAINS } from '../../constants';

export default {
  state: {
    domains: []
  },
  mutations: {
    SET_DOMAINS: (state, payload) => {
      state.domains = payload;
    }
  },
  actions: {
    FETCH_DOMAINS: async (context) => {
      try {
        const response = await axios.get(API_GET_DOMAINS);
        const domains = response.data.result.data;
        context.commit('SET_DOMAINS', domains);
        return domains;
      } catch (e) {
        context.commit('PUSH_ERROR_MESSAGE', `Не удалось получить список доменов. ${e.message}`);
        const domains = [];
        context.commit('SET_DOMAINS', domains);
        return domains;
      }
    }
  },
  getters: {
    DOMAINS: state => {
      return state.domains;
    },
    DOMAIN_BY_ID(state) {
      return userId => {
        return state.domains.find(user => user.id === userId)
      }
    }
  }
}